export const decodeUrl = (url: string) => {
  if (!url) {
    return undefined;
  }

  return new URL(decodeURIComponent(url), window.location.origin);
};
